<template>
  <div class="report">
    <mu-container>
        <mu-form :model="form" class="mu-demo-form" label-position="top" label-width="100">
      <mu-row gutter>
        
        <mu-col span="12" lg="6" sm="6">
          <mu-date-input
            v-model="form.date"
            label="选择日期"
            value-format="YYYY-MM-DD"
            @change="getIncome()"
            label-float
            full-width
            no-display
            
          ></mu-date-input>
        </mu-col>
        <!-- <mu-col span="6" lg="3" sm="3">
          <mu-form-item prop="contain_stop">
            <mu-checkbox v-model="form.contain_stop" value="1" label="包含停用" @change="getIncome()"></mu-checkbox>
          </mu-form-item>
        </mu-col>
        <mu-col span="6" lg="3" sm="3">
          <mu-form-item prop="contain_unpaid">
            <mu-checkbox v-model="form.contain_unpaid" value="1" label="包含记账收款" @change="getIncome()"></mu-checkbox>
          </mu-form-item>
        </mu-col> -->
        
      </mu-row>
      </mu-form>
    </mu-container>
    <mu-container>
      <mu-row>
        <el-table
          v-loading="loading"
          :data="incomes"
          border
          show-summary
          stripe
          style="width: 100%; text-align: center"
          class="budget_list"
          :summary-method="getSummaries"
          height="600"
          ref="table"
        >
          <el-table-column prop="cost_account.title" label="机构名称"  fixed="left">
            <template slot-scope="scope">
              <span
                @click="lookup(scope.row)"
                type="text"
                style="color: #3f51b5"
                >{{ scope.row.jgmc }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="budget_year" label="预算年月">
          </el-table-column> -->
          <el-table-column prop="dysk" sortable label="当月收款">
            <template slot-scope="scope">
              <span>{{ parseInt(scope.row.dysk).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dysr" sortable label="当月收入">
            <template slot-scope="scope">
              <span>{{ parseInt(scope.row.dysr).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="drsk" sortable label="当日收款">
            <template slot-scope="scope">
              <span>{{ parseInt(scope.row.drsk).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="drsr" sortable label="当日收入">
            <template slot-scope="scope">
              <span>{{ parseInt(scope.row.drsr).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="budget_rest" sortable label="剩余">
            <template slot-scope="scope">
              <span>{{ scope.row.budget_rest.toLocaleString()}}</span>
            </template>
          </el-table-column> -->
        </el-table>
      </mu-row>
    </mu-container>

    <Footer active="Report"></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "../../components/Report/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      form: {
        date: "2021-11-01",
        contain_stop:false,
        contain_unpaid:true,
      },
      today:new Date(),
      incomes: [],
      columns: [
        { title: "机构名称", name: "jgmc" },
        // { title: "预算年月", name: "budget_year", align: "center" },
        { title: "当月收款", name: "dysk", align: "center", sortable: true },
        { title: "当月收入", name: "dysr", align: "center", sortable: true },
        { title: "当日收款", name: "drsk", align: "center", sortable: true },
        { title: "当日收入", name: "drsy", align: "center", sortable: true },
      ],
      loading:true,
    };
  },
  created() {
    document.title = "门店每日营收查询";
    this.getDate();
  },
  methods: {
    getDate() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      // let H = Da.getHours();
      // let mm = Da.getMinutes();
      // let s=d.getSeconds()
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      // H = H < 10 ? "0" + H : H;
      this.form.date = y + "-" + m + "-" + d;
    //   this.today = y + "-" + m + "-" + d;
      this.getIncome();
    },
    getIncome() {
      this.$http.post("report/income", this.form).then((res) => {
        if(res.data.code == 204){
          this.$router.push({name:'Login'});  
          return false;
        }
        if (res.data.code != 200) {
          this.$dialog
            .alert({
              message: res.data.msg,
            })
            .then(() => {
              this.$router.push({ name: "Report" });
            });
        }
        this.incomes = res.data.data;
        this.loading = false;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = parseInt(sums[index]).toLocaleString();
          // sums[index] += ' 元';
        } else {
          // sums[index] = 'N/A';
          sums[index] = "";
        }
      });

      return sums;
    },
  },
  updated(){
    this.$nextTick(() => {
      this.$refs['table'].doLayout();
    }) 

  }
};
</script>
<style scoped>
.flow {
  font-size: 14px;
}
.mu-row {
  border-collapse: collapse;
}
.mu-col {
  margin: 0px -1px -1px 0px;
  border: solid #000 1px;
  padding: 4px 10px;
  line-height: 20px;
  text-align: left;
}
.mu-form-item{
    min-height:12px !important;
}
</style>

<style>
.budget_list .cell {
  text-align: center;
  font-weight: bold;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.budget_title {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
}
.budget_detail {
  margin: 75px auto 10px auto;
}
.budget_detail .cell {
  text-align: center;
  font-weight: bold;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.report_table {
  width: 100% !important;
}
.report_table .mu-table-header {
  width: 100% !important;
}

.report {
  margin-bottom: 90px;
  padding: 5px;
}
.report .amount {
  text-align: center;
  font-weight: bold;
}
.select_top {
  font-weight: bold;
  text-align: center;
  color: #000000;
  margin: 10px auto;
  font-size: 20px;
}
.mu-dialog-fullscreen .mu-dialog-body {
  padding: 0;
  max-height: 1200px !important;
}
</style>


